import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {StudentTestControllerService} from "../services/student-test-controller.service";
import {TranslateService} from "@ngx-translate/core";
import {NotificationsService, NotificationType} from "angular2-notifications";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-job-data',
  templateUrl: './job-data.component.html',
  styleUrls: ['./job-data.component.css']
})
export class JobDataComponent {
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private studentTest: StudentTestControllerService,
    public translate: TranslateService,
    private _notifications: NotificationsService
  ) {
  }

  public loading = false;

  form!: FormGroup;
  addForm!: FormGroup;
  updateForm!: FormGroup;

  jobList: any;
  binJobList: any;
  oblList: any;
  bin: any;
  pageLangId: any;
  nameKaz: any;
  nameRus: any;
  oblNameKaz: any;
  oblNameRus: any;
  oblId: any = null;
  raionNameRus: any;
  raionNameKaz: any;
  createdAt: any;
  id: any;
  binUp: any;
  allList: any;

  showWindow = false;
  informWindow = false;
  isEnabled = false;
  disabled = true;

  totalPages: number = 0;
  totalElements: number = 0;
  pageNumber: number = 0;
  hoverOnJob: number = 0;
  size: number = 0;
  searchChecker: number = 1;
  goToPageNumber: number = 1;

  private timeout: any;

  ngOnInit(): void {
    this.form = new FormGroup({
      bin: new FormControl(null, [Validators.pattern(/^\d{12}$/)]),
      searchByName: new FormControl(null),
    });

    this.updateForm = new FormGroup({
      bin: new FormControl(null, Validators.required)
    });

    this.addForm = new FormGroup({
      bin: new FormControl(null, Validators.required)
    });

    this.getObl();

  }

  onKeyup(event: KeyboardEvent) {
    (this.form.get('searchByName') as FormControl).setValue((event.target as HTMLInputElement).value);
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.findAllParam();
    }, 1000);
  }

  goToPage() {
    if (this.goToPageNumber >= 1 && this.goToPageNumber <= this.totalPages) {
      this.changePage(this.goToPageNumber - 1);
    } else {
      this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка','Страница не найдена',
        NotificationType.Error, 5000) : this._notifications.create('Қате', 'Страница не найдена',
        NotificationType.Error, 5000);

    }
  }

  getObl() {
    this.studentTest.findAllOblPOsadForNct()
      .subscribe((res: any) => {
        this.oblList = res;
      });
  }

  findAllParam(changePage: boolean = false){
    if (this.searchChecker == 2){
      if ((this.oblId == 0 && (this.form.get('searchByName')?.value != null && this.form.get('searchByName')?.value != '')) || (this.oblId == null && !!this.form.get('searchByName')?.value)){
        this.studentTest.findByName(localStorage.getItem('Lang'), this.form.get('searchByName')?.value, this.pageNumber, 7)
          .subscribe((res: any) => {
            this.allList = [];
            this.allList = res.content;
            this.totalPages = res.totalPages;
            this.hoverOnJob = 0;
            this.informWindow = true;
            if (changePage) {
              this.pageNumber = this.totalPages < this.pageNumber ? 0 : this.pageNumber;
              this.findAllParam();
            }
          });
      }
      else if (!!this.oblId && this.oblId !== 0 && (this.form.get('searchByName')?.value == null || this.form.get('searchByName')?.value == '')){
        this.studentTest.getJobByOblId(localStorage.getItem('Lang'), this.oblId, this.pageNumber, 7)
          .subscribe((res: any) => {
            this.allList = [];
            this.allList = res.content;
            this.totalPages = res.totalPages;
            this.hoverOnJob = 0;
            this.informWindow = true;
            if (changePage) {
              this.pageNumber = this.totalPages < this.pageNumber ? 0 : this.pageNumber;
              this.findAllParam();
            }
          });
      }
      else if (!!this.oblId && this.oblId !== 0 && !!this.form.get('searchByName')?.value && this.form.get('searchByName')?.value != ''){
        this.studentTest.findAllParams(localStorage.getItem('Lang'), this.oblId, this.form.get('searchByName')?.value, this.pageNumber, 7)
          .subscribe((res: any) => {
            this.allList = [];
            this.allList = res.content;
            this.totalPages = res.totalPages;
            this.hoverOnJob = 0;
            this.informWindow = true;
            if (changePage) {
              this.pageNumber = this.totalPages < this.pageNumber ? 0 : this.pageNumber;
              this.findAllParam();
            }
          });
      }
      else if (!!this.form.get('searchByName')?.value && this.form.get('searchByName')?.value != '' && !!this.oblId && this.oblId !== 0  ){
        this.studentTest.findAllParametr(localStorage.getItem('Lang'), this.form.get('searchByName')?.value, this.oblId, this.pageNumber, 7)
          .subscribe((res: any) => {
            this.allList = [];
            this.allList = res.content;
            this.totalPages = res.totalPages;
            this.hoverOnJob = 0;
            this.informWindow = true;
            if (changePage) {
              this.pageNumber = this.totalPages < this.pageNumber ? 0 : this.pageNumber;
              this.findAllParam();
            }
          });
      }
    }
  }

  getJobByBin() {
    this.studentTest.getFinedBin(this.form.get('bin')?.value)
      .subscribe((res: any) => {
          this.binJobList = res;
          this.hoverOnJob = 0;
        },
        (err: any) => {
          const errorMessage = this.translate.currentLang == 'ru' ? err.error.message : err.error.message;
          this._notifications.create('Ошибка', errorMessage, NotificationType.Error, 5000);
        });
  }

  updateJob(id: any) {
    this.loading = true;
    this.studentTest.updateJobByBin(this.bin)
      .subscribe({
        next: (res: any) => {
          this.binUp = res;
          this.updateForm.get('bin')?.setValue(this.binUp.bin);
          this.loading = false;
        },
        error: (err: any) => {
          this.loading = false;
          this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', err.error.message, NotificationType.Error, 5000) :
            this._notifications.create('Қате', err.error.message, NotificationType.Error, 5000);
        }
      });
  }

  setJob() {
    if (this.addForm.valid) {
      this.studentTest.setJob(this.addForm.get('bin')?.value)
        .subscribe(
          (res: any) => {
            this.showWindow = false;
            this.form.get('bin')?.setValue(this.addForm.get('bin')?.value);
            this.getJobByBin();
            const successMessage = this.translate.currentLang == 'ru' ? 'Добавлено' : 'Добавлено';
            this._notifications.create('Успешно', successMessage, NotificationType.Success, 5000);
          },
          (err: any) => {
            const errorMessage = this.translate.currentLang == 'ru' ? err.error.message : err.error.message;
            this._notifications.create('Ошибка', errorMessage, NotificationType.Error, 5000);
          }
        );
    } else {
      const invalidFields: string[] = [];
      const fieldLabels: { [key: string]: string } = {
        bin: this.translate.currentLang == 'ru' ? 'БИН' : 'БИН',
      };
      for (const controlName in this.addForm.controls) {
        const control = this.addForm.get(controlName);
        if (control?.invalid) {
          invalidFields.push(fieldLabels[controlName] || controlName);
        } else {
        }
      }
      this.addForm.markAllAsTouched();
      const errorMessage =
        this.translate.currentLang == 'ru'
          ? `Пожалуйста, заполните обязательные поля: ${invalidFields.join(', ')}.`
          : `Барлық міндетті өрістерді толтырыңыз: ${invalidFields.join(', ')}.`;
      this._notifications.create(
        this.translate.currentLang == 'ru' ? 'Предупреждение' : 'Ескерту',
        errorMessage,
        NotificationType.Error,
        5000
      );
    }
  }

  oknoData(job: any) {
    this.hoverOnJob = job.id;
    this.bin = job.bin;
    this.nameRus = job.nameRus;
    this.nameKaz = job.nameKaz;
    this.oblNameKaz = job.oblNameKaz;
    this.oblNameRus = job.oblNameRus;
    this.raionNameRus = job.raionNameRus;
    this.raionNameKaz = job.raionNameKaz;
    this.createdAt = job.createdAt;
  }

  changePage(page: number): void {
    if (page >= 0 && page < this.totalPages + 1) {
      this.pageNumber = page;
      this.goToPageNumber = page + 1;
      this.findAllParam();
    }
  }

  openWindow() {
    this.showWindow = !this.showWindow;
    this.addForm.reset();
  }

  closeWindow() {
    this.showWindow = false;
    this.addForm.reset();
  }

}
